import { FutureProjectionCarbonEmissionsCard } from "components/organisms/Charts";
import { useCumulativeCarbonEmissionsCard } from "queries/Reports/Baseline/useCumulativeCarbonEmissionsCard";

function CumulativeCarbonEmissionsCard({ filtersetUid }: { filtersetUid: string }) {
    const { data, isLoading, error } = useCumulativeCarbonEmissionsCard(filtersetUid);
    return (
        <FutureProjectionCarbonEmissionsCard
            data={data}
            cumulative={true}
            loading={isLoading}
            error={error?.toString()}
        />
    );
}

export default CumulativeCarbonEmissionsCard;
